import React from 'react'

const ToothItem = ({ tooth: { name } }) => {
    return <input type="checkbox" id={name} className="ap-tooth-checkbox" />;
  };
  
  export default ToothItem